'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _evaluateSearchType = require('./evaluateSearchType');

var startsWith = function startsWith(searchvalue, target) {
  return searchvalue && searchvalue.indexOf(target) === 0;
};

exports.default = function (prevLocation, searchBySortModeChange, searchTypeOverride, totalResults) {
  var events = void 0;

  if (searchBySortModeChange) {
    events = 'event27';
  } else if (startsWith(prevLocation, '/jobs') && searchTypeOverride !== _evaluateSearchType.MORE_OPTIONS) {
    events = 'event24';
  } else {
    events = 'event21';
  }

  if (totalResults === 0) {
    events = events + ',event23';
  }

  return events;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/utils/evaluateSearchEvents.js
 ** module id = 435
 ** module chunks = 0
 **/